import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase/credenciales';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faRotate, faAdd, faBan, faReply } from '@fortawesome/free-solid-svg-icons';
import './SettingStates.css';

const SettingStates = () => {
    const [states, setStates] = useState([]);
    const [filteredStates, setFilteredStates] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [editingState, setEditingState] = useState(null);
    const [newState, setNewState] = useState({
        name: "",
    });
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchStates = async () => {
        const querySnapshot = await getDocs(collection(db, 'Estados'));
        const statesData = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        setStates(statesData);
        setFilteredStates(statesData);
        setLoading(false);
    };

    useEffect(() => {
        fetchStates();
    }, []);

    useEffect(() => {
        const results = states.filter(state =>
            state.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredStates(results);
    }, [searchTerm, states]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewState({ ...newState, [name]: value });
    };

    const handleEditState = (state) => {
        setEditingState(state);
        setNewState(state);
    };

    const handleUpdateState = async () => {
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "¿Deseas actualizar este estado?",
            showCancelButton: true,
            confirmButtonText: "Sí, actualizar!",
            cancelButtonText: "No, cancelar!",
        });

        if (result.isConfirmed) {
            try {
                await updateDoc(doc(db, 'Estados', editingState.id), newState);
                Swal.fire("Actualizado", "El estado ha sido actualizado exitosamente.");
                setEditingState(null);
                setNewState({
                    name: "",
                });
                fetchStates();
            } catch (error) {
                console.error("Error al actualizar el estado en la base de datos", error);
                Swal.fire("Error", "No se pudo actualizar el estado.");
            }
        }
    };

    const handleDeleteState = async (id) => {
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "No podrás revertir esto!",
            showCancelButton: true,
            confirmButtonText: "Sí, bórralo!",
            cancelButtonText: "No, cancelar!",
        });

        if (result.isConfirmed) {
            try {
                await deleteDoc(doc(db, 'Estados', id));
                Swal.fire("Borrado!", "El estado ha sido borrado.");
                fetchStates();
            } catch (error) {
                console.error("Error al borrar el estado en la base de datos", error);
                Swal.fire("Error", "No se pudo borrar el estado.");
            }
        }
    };
    return (
        <div className="setting-states-container">
            <div className="title-actions">
                <h1 className="title">Gestión de Estados</h1>
                <div className="btn-actions">
                    <button className="btn-cancel" title="Regresar" onClick={() => navigate('/admin')}><FontAwesomeIcon icon={faReply} /></button>
                    <button className="btn-plus" title="Agregar un estado" onClick={() => navigate('/admin/estados')}><FontAwesomeIcon icon={faAdd} /></button>
                </div>
            </div>
            <input
                type="text"
                placeholder="Buscar por nombre del estado"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
            />
            {loading ? (
                <div className="spinner"></div>
            ) : (
                <div className="state-list">
                    {filteredStates.length === 0 ? (
                        <p className="no-results">El estado que buscas no se encuentra registrado aún.</p>
                    ) : (
                        isMobile ? (
                            filteredStates.map(state => (
                                <div key={state.id} className="state-card">
                                    {editingState && editingState.id === state.id ? (
                                        <div className="edit-form">
                                            <div className="form-group">
                                                <label htmlFor="name">Nombre</label>
                                                <input
                                                    type="text"
                                                    id="name"
                                                    name="name"
                                                    placeholder="Nombre"
                                                    value={newState.name}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="btn-form-actions">
                                                <button className="btn-ac" title="Guardar" onClick={handleUpdateState}><FontAwesomeIcon icon={faAdd} /></button>
                                                <button className="btn-de" title="Cancelar" onClick={() => setEditingState(null)}><FontAwesomeIcon icon={faBan} /></button>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="state-info">
                                                <h3>{state.name}</h3>
                                            </div>
                                            <div className="btn-actions">
                                                <button className="btn-ed" title="Actualizar" onClick={() => handleEditState(state)}><FontAwesomeIcon icon={faRotate} /></button>
                                                <button className="btn-de" title="Eliminar" onClick={() => handleDeleteState(state.id)}><FontAwesomeIcon icon={faTrash} /></button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="state-list">
                                <div className="state-header">
                                    <span>Nombre</span>
                                    <span>Acciones</span>
                                </div>
                                <ul>
                                    {filteredStates.map(state => (
                                        <li key={state.id}>
                                            {editingState && editingState.id === state.id ? (
                                                <div className="edit-form-states">
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        placeholder="Nombre del Estado"
                                                        value={newState.name}
                                                        onChange={handleInputChange}
                                                    />
                                                    <div className="btn-actions">
                                                        <button className="btn-ac" title="Guardar" onClick={handleUpdateState}> <FontAwesomeIcon icon={faAdd} /></button>
                                                        <button className="btn-de" title="Cancelar" onClick={() => setEditingState(null)}><FontAwesomeIcon icon={faBan} /></button>
                                                    </div>
                                                </div>
                                            ) : (
                                                    <>
                                                    <span>{state.name}</span>
                                                    <button className="btn-ed" title="Actualizar" onClick={() => handleEditState(state)}> <FontAwesomeIcon icon={faRotate} /></button>
                                                    <button className="btn-de" title="Eliminar" onClick={() => handleDeleteState(state.id)}><FontAwesomeIcon icon={faTrash} /></button>
                                                    </>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )
                    )}
                </div>
            )}
        </div>
    );
};

export default SettingStates;